import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex -space-x-1 items-center relative z-10" }
const _hoisted_2 = { class: "relative inline-block text-left" }
const _hoisted_3 = {
  key: 0,
  class: "absolute -top-1 -left-1 w-5 h-5 inline-flex bg-red text-white rounded-full justify-center items-center text-xs font-medium"
}
const _hoisted_4 = {
  class: "origin-top-right absolute right-0 mt-2 w-96 rounded-md shadow-lg bg-white dark:bg-gray-bluer-600 ring-1 ring-black ring-opacity-5 focus:outline-none border border-transparent dark:border-gray-bluer-700 z-10",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "menu-button",
  tabindex: "-1"
}
const _hoisted_5 = { role: "none" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm px-4 py-2 text-center text-gray-bluer-100 leading-tight" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Messages in here are not saved, you'll only see messages from the moment you join and when you leave they're gone forever.")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col-reverse pt-4 pb-6 px-4 border-t border-gray-blue-300 overflow-scroll",
  style: {"max-height":"350px"}
}
const _hoisted_8 = {
  key: 0,
  class: "flex-grow text-center leading-none text-xs font-medium"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "py-6 px-4 text-center"
}
const _hoisted_13 = { class: "flex w-full border-t border-gray-blue-300" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Send", -1)
const _hoisted_15 = ["src", "alt"]

import { onMounted, onUnmounted, toRefs, watch, ref, computed } from "vue";
import { useStore }                                             from "vuex";
import { userHook }                                             from "../../hooks/user";
import _                                                   from "lodash";
import { api as Api }   from "@greywind/common";


export default /*#__PURE__*/_defineComponent({
  props: {
        channel: {
            type:     String,
            required: true
        },
        classes: {
            type:     String,
            required: false,
            default:  'bg-gray-blue-100 dark:bg-gray-bluer-800'
        }
    },
  setup(__props) {

const props = __props


const { channel, classes } = toRefs( props );
const presenseUsers        = ref( [] );
const messages             = ref( [] );
const message              = ref( null );
const open                 = ref( false );
const unread               = computed( () => messages.value.filter( m => !m.read ).length );

const store                  = useStore();
const { user, activeEnvironment } = userHook( store );

onMounted( (): void => initiatePresense( channel.value ) );
onUnmounted( (): void => destroyPresense( channel.value ) );

watch( () => channel.value, ( value, old ) => {
    destroyPresense( old );
    initiatePresense( value );
} );

const markViewed = (): void => {
    messages.value.forEach( ( m, i ) => {
        m.read = true;

        messages.value[ i ] = m;
    } );
}

const sendMessage = async (): Promise<void> => {
    if ( message.value.length > 1 ) {
        await Api.request( 'post', 'denfield-app-user/denfield-package-broadcasting/broadcast-message', {
            message: message.value,
            channel: channel.value
        }, activeEnvironment.value.meta.api.url );

        message.value = '';
    }
}

const handleMessage = ( message: any ): void => {
    if ( open.value || ( message.user && message.user.id && message.user.id === user.value.id ) ) {
        message.read = true;
    }

    messages.value.splice( 0, 0, message );
}

const initiatePresense = ( channel: string ): void => {
    if ( !window.Echo ) return;

    window.Echo.join( channel )
          .here( users => presenseHere( users ) )
          .joining( user => presenseJoining( user ) )
          .leaving( user => presenseLeaving( user ) )
          .listen( '.Greywind\\Broadcasting\\Events\\NewMessage', e => handleMessage( e.message ) )
          .error( error => {
              console.log( error )
          } );
}

const destroyPresense = ( channel: string ): void => {
    if ( !window.Echo ) return;

    window.Echo.leave( channel );
}

const presenseHere = ( users: any[] ): void => {
    presenseUsers.value = users;

    users.forEach( u => messages.value.splice(
        0,
        0,
        {
            message: `${ ( u.id === user.value.id ? 'You have' : u.name + ' has' ) } joined the chat.`,
            read:    true,
            system:  true
        }
    ) )
}

const presenseJoining = ( u: any ): void => {
    const users = _.cloneDeep( presenseUsers.value );
    users.push( u );

    presenseUsers.value = users;

    messages.value.splice( 0, 0, {
        message: `${ u.name } has joined the chat.`,
        read:    true,
        system:  true
    } );
}

const presenseLeaving = ( us: any ): void => {
    const users = _.cloneDeep( presenseUsers.value );
    users.splice( users.findIndex( u => u.id === us.id ), 1 );

    presenseUsers.value = users;

    messages.value.splice( 0, 0, {
        message: `${ us.name } has left the chat.`,
        read:    true,
        system:  true
    } );
}

const getImg = ( us: any ): any => {
    return require( `@greywind/ui/public/avatars/memoji/${ ( us.meta && us.meta.memoji ? us.meta.memoji : '12' ) }.png` );
}

return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_popper = _resolveComponent("x-popper")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_x_popper, {
        arrow: "",
        hover: "",
        content: "Quick Chat"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            id: "menu-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {open.value = !open.value; markViewed()}),
            class: "relative inline-flex justify-center items-center rounded-full ring-2 ring-white h-12 w-12 cursor-pointer text-gray-bluer-100 hover:text-theme transition duration-150 ease-in-out"
          }, [
            _createVNode(_component_x_icon, {
              icon: "fontawesome.paper-plane",
              class: "transform rotate-45 w-6 h-6"
            }),
            (_unref(unread))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(unread)), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (messages.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "flex flex-col mb-3"
                      }, [
                        (message.system)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(message.message), 1))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["inline-flex whitespace-normal w-auto rounded-md text-sm leading-tight py-2 px-4", { 'bg-theme text-white justify-end ml-auto': message.user.id === _unref(user).id, 'bg-gray-blue-500 text-gray-bluer-300 justify-start mr-auto': message.user.id !== _unref(user).id }]),
                              style: {"max-width":"80%"},
                              innerHTML: message.message
                            }, null, 10, _hoisted_9)),
                        (message.user || message.time)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 2,
                              class: _normalizeClass(["text-xs font-medium mt-1 mr-1 text-gray-bluer-100", { 'text-right': message.user.id === _unref(user).id, 'text-left': message.user.id !== _unref(user).id }])
                            }, [
                              _createElementVNode("span", null, _toDisplayString(message.user.name), 1),
                              _hoisted_10,
                              (message.time)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(message.time), 1))
                                : _createCommentVNode("", true)
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, "...")),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Type to send message...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message).value = $event)),
                  class: "flex-grow border-none rounded-bl-md text-sm placeholder-gray-bluer-50"
                }, null, 512), [
                  [_vModelText, message.value]
                ]),
                _createElementVNode("span", {
                  onClick: sendMessage,
                  class: "flex items-center px-2 py-1 bg-theme text-white rounded-br-md hover:bg-theme-600 cursor-pointer"
                }, [
                  _hoisted_14,
                  _createVNode(_component_x_icon, {
                    icon: "fontawesome.paper-plane",
                    class: "transform rotate-45 w-5 h-5 ml-3"
                  })
                ])
              ])
            ])
          ], 512), [
            [_vShow, open.value]
          ])
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presenseUsers.value, (user, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: _normalizeClass(["h-12 w-12 rounded-full ring-2 ring-white", _unref(classes)]),
        style: _normalizeStyle(`z-index: ${(presenseUsers.value.length - i) * 1.5};`)
      }, [
        _createVNode(_component_x_popper, {
          arrow: "",
          hover: "",
          content: user.name
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "inline-block h-12 w-12 rounded-full",
              src: getImg(user),
              alt: user.name
            }, null, 8, _hoisted_15)
          ]),
          _: 2
        }, 1032, ["content"])
      ], 6))
    }), 128))
  ], 512)), [
    [_vShow, presenseUsers.value.length > 1]
  ])
}
}

})